import {TIMEOUT_STRING} from "../constants";
import {getNodeId} from "../Utility";

const postMessagePromises = {};
function generateGuid(){
    /**
     * @return {string}
     */
    function S4() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(TIMEOUT_STRING);
                console.log("TimeOut: " + message.method);
            },timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

export async function getNodeCapabilityFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getNodeCapability',
        args: {}
    }, '*');
}

export async function getFeaturesFromParent(features) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features, stationCode: getNodeId()}
    }, '*');
}

export async function getCycleDataFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCycleDataFromParent',
        args: {}
    }, '*');
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export async function getDocumentURL() {
    return await postMessagePromised(window.parent, {
        method: 'getDocumentURL',
        args: {}
    }, '*');
}

export async function getSmartStowEnablementFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getSmartStowEnabled',
        args: {}
    }, '*');
}

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*',200);
}

export function setSelectedCycle(selectedCycle) {
    window.parent.postMessage({
        method: 'setSelectedCycle',
        args: {selectedCycle: selectedCycle}
    }, "*");
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendCycleDataToChild": sendCycleDataToChild,
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendDocumentURL": sendDocumentURL,
    "sendCapabilityResponse": sendCapabilityResponse,
    "sendLocaleResponse": sendChildData,
    "sendFeatureStatus": sendResponseData,
    "sendSmartStowEnabled": sendSmartStowEnabled
}

function sendCycleDataToChild(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendSmartStowEnabled(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendApiGatewayResponse(data) {
    if(postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendDocumentURL(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendCapabilityResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendChildData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendResponseData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}



// WEBPACK FOOTER //
// ./src/handler/ParentDataHandler.js